/**
 * Where a published website sends its enquiries — MTC-FCS-017/033.
 * ============================================================================
 * ── ABSOLUTE ON PURPOSE ────────────────────────────────────────────────────
 * The quote form is the whole of the Lead Generation tier, and a published
 * page is not served from here: it goes out on the contractor's own subdomain
 * (and later their own domain) from a static host that has no /api of its own.
 * A relative action would post to a route that does not exist there, so the
 * only thing the contractor is paying for would answer 404 — and only once
 * the site was live, which is the worst moment to find out.
 *
 * A form POST to another origin is an ordinary navigation, not a fetch, so
 * this needs no CORS: the browser posts and renders whatever comes back.
 *
 * GATSBY_SITE_URL is a public address, not a secret, which is why it carries
 * the prefix that puts it in the browser bundle — see src/lib/env-snapshot.js
 * for the rule about what must never have it.
 */
import { apiUrl } from "../config/api"

/* An Edge Function, not a route on the site — FCS-055. GitHub Pages serves
   files and nothing else, so /api/lead does not exist on the customer's
   subdomain OR on the main domain. This is the address that answers. */
export const LEAD_ENDPOINT = apiUrl("lead")

/** What the endpoint accepts, so the form cannot send what it will not store. */
export const LEAD_LIMITS = { name: 120, phone: 40, email: 160, service: 120, message: 2000 }
